import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CreatedTheme, NewTheme, Theme } from './theme.model';
import { from, Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import PocketBase, { ListResult } from 'pocketbase';
import { ThemeListRecord } from './pocketbase-type';
import { Flag } from './flags';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  apiURL = environment.apiURL || 'http://localhost:5003';
  pb = new PocketBase(this.apiURL);
  themesDb = this.pb.collection('theme');
  themeListDb = this.pb.collection('theme_list');
  wordFoundDb = this.pb.collection('word_found');

  constructor() {}

  getThemes(page = 1, pageSize = 15, flag: Flag | null): Observable<ListResult<ThemeListRecord>> {
    return from(
      this.themeListDb.getList<Theme>(page, pageSize, {
        sort: '-wordsFound',
        filter: flag?.tag ? `lang="${flag?.tag}"` : '',
      }),
    );
  }

  getTheme(key: string) {
    return from(this.themesDb.getOne<Theme>(key));
  }

  updateWordFoundCount(themeId: string | undefined) {
    if (!themeId) return of({});
    return from(this.wordFoundDb.create({ theme: themeId }));
  }

  createTheme(theme: NewTheme) {
    return from(this.themesDb.create<CreatedTheme>(theme));
  }
}
